/**
 * CSRF Token Sync Component
 * Syncs CSRF token from context to ApiService
 */

import { useEffect } from 'react';
import { useCsrf } from '../../contexts/CsrfContext';
import apiService from '../../services/ApiService';

const CsrfSync = () => {
  const { csrfToken, loading, error } = useCsrf();

  useEffect(() => {
    if (csrfToken && !loading) {
      // Update ApiService with the new CSRF token
      apiService.setCsrfToken(csrfToken);
    }
  }, [csrfToken, loading]);

  useEffect(() => {
    if (error) {
      console.error('⚠️ CSRF token fetch error:', error);
    }
  }, [error]);

  // This component doesn't render anything
  return null;
};

export default CsrfSync;

